// ============================================================================
// CONSTANTES E CORES
// ============================================================================

export const COLORS = {
  primary: '#0E63FF',
  greenLean: '#1DA86A',
  greenSoft: '#EAF7F1',
  redCritical: '#D64545',
  redSoft: '#FCEAEA',
  blueKPI: '#407BFF',
  grayText: '#4A4A4A',
  bgGeneral: '#F5F7FA',
  divider: 'rgba(229, 229, 229, 0.4)'
};

export const COLORS_DARK = {
  primary: '#3B82F6',
  greenLean: '#22C55E',
  greenSoft: '#052e16',
  redCritical: '#EF4444',
  redSoft: '#450a0a',
  blueKPI: '#60A5FA',
  grayText: '#D4D4D4',
  bgGeneral: '#1a2232',
  divider: 'rgba(45, 59, 78, 0.6)'
};
